import { ShieldCheckIcon } from "@heroicons/react/24/outline";
import type { ProjectDto } from "@shared/types";
import { Alert, Button } from "./ui";
import { adminHref } from "../lib/platform-admin";

// Shown only for the Access platform console while it is inspecting a project
// outside the Better Auth membership model. With multi-member
// projects the banner lists every owner so the viewer can identify whom
// to contact. Pass `null` for the project while loading.
export function OwnerBanner({
  project,
  backHref = adminHref("/users"),
}: {
  project: ProjectDto | null;
  backHref?: string;
}) {
  if (!project || project.viewerRole !== "platform_admin") return null;

  const owners = project.members.filter((m) => m.role === "owner");
  const labels = owners.map((o) => o.name ?? o.email).join(", ");

  return (
    <Alert
      tone="warning"
      icon={<ShieldCheckIcon class="h-5 w-5" aria-hidden />}
      action={
        <Button as="a" href={backHref} size="sm" variant="secondary">
          ユーザー管理に戻る
        </Button>
      }
    >
      <span>
        管理者として閲覧中
        {owners.length > 0 && (
          <>
            : owner{" "}
            <span class="font-medium text-fg">{labels}</span>
          </>
        )}
      </span>
    </Alert>
  );
}
